import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ content: null, refresh: () => {} });

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);

  const load = useCallback(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <SiteContext.Provider value={{ content, refresh: load }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
